import { createAsyncThunk } from "@reduxjs/toolkit";
import { STATION_DEVICE_CONNECTORS } from "../../../API/UserApi";
import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const getStationDeviceConnectorsListAPI: any = createAsyncThunk(
  "getStationDeviceConnectors",
  async (params: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.get(STATION_DEVICE_CONNECTORS, {
        // headers: {
        //   // istoken: "false",
        //   token: JSON.parse(token),
        // },
        headers: commonHead,
        params: params,
      });
      return { users: res };
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ error: error.message });
      }
    }
  }
);
